// 9fbef606107a605d69c0edbcd8029e5d
import { createSelector } from 'reselect';
import { parseBoolean, getDateObject } from '@tcp/core/src/utils';
import BagPageSelectors from '@tcp/core/src/components/features/CnC/BagPage/container/BagPage.selectors';
import { ORDERS_REDUCER_KEY } from '../../../../../constants/reducer.constants';
import { getUserLoggedInState } from '../../User/container/User.selectors';

const emptyAry = [];
const emptyObj = {};
const getState = (state) => state[ORDERS_REDUCER_KEY];

/**
 * Selector function to return redux error
 * @param { object } state reduxStore state
 */
export const getOrdersListState = createSelector(
  getState,
  (state) => state && state?.get('ordersList')
);

export const getOrdersListStateForStore = createSelector(
  getState,
  (state) => state && state?.get('ordersListForStore')
);

export const getDeliveredOrderIdsState = createSelector(
  getState,
  (state) => state && state?.get('deliveredOrderIds')
);

export const getOrdersState = createSelector(
  getOrdersListState,
  (orderListState) => orderListState && orderListState?.orders
);

export const getOrdersForStoreState = createSelector(
  getOrdersListStateForStore,
  (state) => state && state?.orders
);

export const getOrderListFetchingState = (state) => {
  return getState(state)?.get('isFetching');
};

export const getOrdersLoader = (state) => {
  return getState(state)?.get('isOrderLoading');
};

export const getDeliveryOrderListFetchingState = (state) => {
  return getState(state)?.get('isDeliveredFetching');
};

export const getLoadMoreState = (state) => {
  return getState(state)?.get('isLoadMoreActive');
};

export const getChangedSiteId = (state) => {
  return getState(state)?.get('changedSiteId');
};

export const getSelectedYear = (state) => {
  return getState(state)?.get('selectedYear');
};

export const getPagination = (state) => {
  return getState(state)?.get('pageNum');
};

export const getFilterModalState = (state) => {
  return getState(state)?.get('modalState');
};
export const getOrderFilterOptions = (state) => {
  return getState(state)?.get('orderFilterOptions');
};

export const getCompanyId = (state) => {
  return getState(state)?.get('companyId');
};

export const getOrderError = (state) => {
  return getState(state)?.get('isOrderError');
};

export const getPreviewOrderId = createSelector(getOrdersListState, (orderListState) => {
  if (orderListState && orderListState?.orders && orderListState?.orders?.length > 0) {
    return orderListState?.orders[0]?.orderNumber;
  }
  return null;
});

export const getUpcomingOrders = createSelector(getOrdersListState, (orderListState) => {
  if (orderListState && orderListState?.orders) {
    return orderListState?.orders?.filter((order) => order?.isActiveOrder);
  }
  return null;
});

export const getShowOrderListWithItemDetails = (state, props) => {
  if (
    props &&
    props?.router &&
    props?.router?.asPath &&
    props?.router?.asPath?.includes('showOrderListDetails')
  ) {
    return true;
  }
  return (
    state?.session &&
    state?.session?.siteDetails &&
    parseBoolean(state?.session?.siteDetails?.IS_ORDERLIST_ITEMDETAILS_REQUIRED)
  );
};

export const getAccountOrdersAPISwitch = (state) => {
  return (
    state?.session &&
    state?.session?.siteDetails &&
    parseBoolean(state?.session?.siteDetails?.IS_ORDERLIST_MICROSERVICE_ACTIVE)
  );
};

export const getRecentOrderDetailsState = createSelector(
  getState,
  (state) => state && state?.get('recentOrderDetails')
);

const getSortedList = (pastOrdersListItems) => {
  // Sort order list items in descending order
  if (pastOrdersListItems && pastOrdersListItems?.length > 1) {
    return pastOrdersListItems?.sort(
      (prev, next) =>
        getDateObject(next?.orderDate)?.getTime() - getDateObject(prev?.orderDate)?.getTime()
    );
  }
  return pastOrdersListItems;
};

const getOldOrderList = (orderList) => {
  return orderList ? orderList?.filter((order) => !order?.isActiveOrder) : emptyAry;
};

export const getShippingCaraouselOrderList = (state) => {
  const ordersListItemData = getOrdersState(state) || emptyAry;
  return getSortedList(ordersListItemData);
};

export const getOrderListForStore = (state) => {
  const ordersListItemData = getOrdersForStoreState(state) || emptyAry;
  return getSortedList(ordersListItemData);
};

export const getOrderHistoryProductIds = (state) => {
  if (getUserLoggedInState(state)) {
    const getDeliveredOrderIdsData = getDeliveredOrderIdsState(state) || emptyObj;

    if (getDeliveredOrderIdsData?.orderIds) {
      return getDeliveredOrderIdsData?.orderIds;
    }
  }
  return BagPageSelectors.getCartProductIds(state);
};

export const getNewOrdersListItem = (state, props) => {
  const newOrderHistory = getShowOrderListWithItemDetails(state, props);
  const ordersListItemData = getOrdersState(state) || emptyAry;
  return newOrderHistory ? getOldOrderList(ordersListItemData) : getSortedList(ordersListItemData);
};

export const getAccountDrawerOrdersListState = createSelector(
  getState,
  (state) => state && state?.get('accountDrawerOrdersList')
);

export const getAccountDrawerOrdersState = createSelector(
  getAccountDrawerOrdersListState,
  (accountDrawerOrdersListState) =>
    accountDrawerOrdersListState && accountDrawerOrdersListState?.orders
);

export const getAccountDrawerOrdersFetchingState = (state) => {
  return getState(state)?.get('isAccountDrawerOrdersFetching');
};
